<template>
  <div id="isInitial" v-if="isInitial">
    <Loading :loading="this.loading"></Loading>
    <div v-show="!loading" class="content-wrapper" v-bind:class="{ modal_open: modalActive }">
      <div class="container">
        <article>
          <div class="section white-panel pd0">
            <ul class="pt5p pr5p pb0 pl5p">
              <router-link to="#care1">
                <li class="internal-link mb12 radius8">
                  <a  v-on:click='sameUrlScroll("1")' class="color-carcare1 text-decoration-none pt16 pb16 pl12 pr16 flex">
                    <img src="lib/images/carcare/ic_carcare_01.svg" alt="1" class="mr12">
                    <span class="fs18 font-weight-bold line-height1_3 flex1">整備費用も含めた<br>コミコミ価格</span>
                    <img src="lib/images/carcare/ic_carcare_04.svg" alt="">
                  </a>
                </li>
              </router-link>
              <router-link to="#care2">
                <li class="internal-link mb12 radius8">
                  <a  v-on:click='sameUrlScroll("2")' class="color-carcare2 text-decoration-none pt16 pb16 pl12 pr16 flex">
                    <img src="lib/images/carcare/ic_carcare_02.svg" alt="1" class="mr12">
                    <span class="fs18 font-weight-bold line-height1_3 flex1">充実のアフターケアと<br>安心の整備基準</span>
                    <img src="lib/images/carcare/ic_carcare_05.svg" alt="">
                  </a>
                </li>
              </router-link>
              <router-link to="#care3">
                <li class="internal-link mb12 radius8">
                  <a  v-on:click='sameUrlScroll("3")' class="color-carcare3 text-decoration-none pt16 pb16 pl12 pr16 flex">
                    <img src="lib/images/carcare/ic_carcare_03.svg" alt="1" class="mr12">
                    <span class="fs18 font-weight-bold line-height1_3 flex1">見積りから決済まで<br>アプリで完了</span>
                    <img src="lib/images/carcare/ic_carcare_06.svg" alt="">
                  </a>
                </li>
            </router-link>
            </ul>
            <div v-if="detail[0].id === ''">
              <div v-if="ssInfo.komikomi_flag === 1">
                <router-link :to="{ name: 'Car', params: { tsId, ssInfo, profileInfo, nativeData }}" style="text-decoration: none;" v-on:click.native="eventTrackStartCar()">
                  <button class="button fs16 pd20 mt24 radius200 w75p">見積りを始める</button>
                </router-link>
                <div class="section">
                  <div class="bg-gray2 pd16 mt8 mb4">
                    <p class="fs13 mb0">お客様のマイSSでの受け付けとなります。外車や年式の古い車両はご利用いただけません。車検対象車両の条件は<a href="#" v-on:click='modalOpen()' class="color-green2">こちら</a>をご覧ください。</p>
                  </div>
                </div>
              </div>
              <div v-else>
                <div class="section white-panel pt28 pb24 mb2p">
                  <p class="fs14">お客様のマイSSではアプリからの車検受付をしておりません。車検サービスとご利用する場合はアプリ車検を取り扱っているSSをマイSSにする必要があります。</p>
                  <div class="border-solid-gray radius16 pd20 mt20">
                    <div v-if="ssInfo.length !== 0">
                      <p class="fs14 mb4">ご登録中のマイSS</p>
                      <h2 class="fs16 font-weight-bold mb20">{{ $route.params.ssInfo.ss_name }}</h2>
                    </div>
                    <div v-else>
                      <p class="fs14 mb4">マイSSが登録されていません</p>
                    </div>
                    <a v-on:click='appChangeMySs()' style="text-decoration: none;"><button class="button fs16 mb8 w80p">マイSSを変更</button></a>
                  </div>
                </div>
              </div>
            </div>

            </div>
          <section id="care1" class="section white-panel pd0">
            <div class="bg-carcare1 pt24 pb24 pl16 pr16">
              <h2 class="fs18 color-white text-center">1 整備費用も含めたコミコミ価格</h2>
            </div>

            <div class="section white-panel">
              <div class="text-center">
                <p class="mt8 mb12"><img src="lib/images/carcare/ic_carcare_07.svg" alt=""></p>
                <p class="fs14 font-weight-bold mb8">オイルやバッテリーなど<br>
                  36部品を、異常があれば<br>
              <span class="color-carcare1">追加費用なしで整備・部品交換</span></p>

                <p class="mt28 mb12"><img src="lib/images/carcare/ic_carcare_08.svg" alt=""></p>
                <p class="fs14 font-weight-bold mb8">整備箇所は店頭で点検し、<br>
                  <span class="color-carcare1">整備員</span>がしっかりとご説明</p>

                <p class="mt28 mb12"><img src="lib/images/carcare/ic_carcare_09.svg" alt=""></p>
                <p class="fs14 font-weight-bold mb8">タイヤの交換は、お好きなメーカーの<br>
                製品を選んで別途ご購入ください</p>

                <div class="bg-gray2 pd16 mt24 mb20">
                  <p class="fs13 mb0">タイヤやバンパー、フロントガラスなど<br>
                    一部の部品は定額整備の対象外となります。<br>
                  定額整備の対象部品は<a href="#" v-on:click="toAgreement()" class="color-green2">こちら</a>を御覧ください。</p>
                </div>
              </div>
            </div>
          </section>

          <section id="care2" class="section pd0">
            <div class="bg-purple2 pt24 pb24 pl16 pr16">
              <h2 class="fs18 color-white text-center">2 充実のアフターケアと安心の整備基準</h2>
            </div>

            <div class="section white-panel mb2p">
              <h3 class="fs18 line-height1_4 mt8 mb20 ml4 mr4">安全とお得を両立する<br>
              メリハリの効いた整備基準</h3>
              <div class="flex align-items-center mb28 ml8 mr8">
                <img src="lib/images/carcare/ic_carcare_10.svg" alt="">
                <p class="fs14 font-weight-bold flex1 mb0 ml16">安全に関わる<span class="color-carcare2">異常があった部品は<br>
                全て整備・部品交換</span></p>
              </div>
              <div class="flex align-items-center mb28 ml8 mr8">
                <img src="lib/images/carcare/ic_carcare_11.svg" alt="">
                <p class="fs14 font-weight-bold flex1 mb0 ml16">さらに事故予防に重要な<br>
                  <span class="color-carcare2">ブレーキ、エンジン関連部品は<br>
                徹底した予防整備</span>を実施</p>
              </div>
              <div class="flex align-items-center mb16 ml8 mr8">
                <img src="lib/images/carcare/ic_carcare_12.svg" alt="">
                <p class="fs14 font-weight-bold flex1 mb0 ml16">適正な整備基準に基づき、<br>必要な箇所だけをしっかり整備することで<span class="color-carcare2">お得な価格</span>を実現</p>
              </div>
            </div>

            <div class="section white-panel">
              <h3 class="fs18 line-height1_4 mt8 mb20 ml4 mr4">車検後の点検・保証も安心でお得</h3>
              <div class="flex align-items-center mb28 ml8 mr8">
                <img src="lib/images/carcare/ic_carcare_13.svg" alt="">
                <p class="fs14 font-weight-bold flex1 mb0 ml16">車検1年後の<span class="color-carcare2">法定12か月点検を<br>
                無料</span>で実施</p>
              </div>
              <div class="flex align-items-center mb16 ml8 mr8">
                <img src="lib/images/carcare/ic_carcare_14.svg" alt="">
                <p class="fs14 font-weight-bold flex1 mb0 ml16"><span class="color-carcare2">車検後半年</span>または走行距離<span class="color-carcare2">1万キロ以内</span>に整備対象36部品で異常が発生した場合は<span class="color-carcare2">無料で整備・交換</span>を実施</p>
              </div>
            </div>
          </section>

          <section id="care3" class="section pd0">
            <div class="bg-carcare3 pt24 pb24 pl16 pr16">
              <h2 class="fs18 color-white text-center">3 見積りから決済までアプリで完了</h2>
            </div>

            <div class="section white-panel mb2p">
              <h3 class="fs18 line-height1_4 mt8 mb20 ml4 mr4">簡単2ステップでお見積り</h3>
              <div class="flex bg-gray2 radius20 pd20 mb8">
                <div class="">
                  <p><img src="lib/images/carcare/ic_carcare_15.svg" alt="ステップ1"></p>
                  <p class="fs14 font-weight-bold">アプリから車検証のQRコードを読み取り</p>
                </div>
                <div class="ml20">
                  <p><img src="lib/images/carcare/ic_carcare_16.svg" alt="ステップ2"></p>
                  <p class="fs14 font-weight-bold">ダッシュボードを確認し累計走行距離を入力</p>
                </div>
              </div>
              <p class="text-center"><img src="lib/images/carcare/ic_carcare_22.svg" width="28" height="28" alt=""></p>
              <div class="text-center mt12">
                  <p class="fs18 font-weight-bold text-center carcare3-result pt4 mb12">個人情報の入力なしで<br>車検料金をお見積り！</p>
              </div>
            </div>

            <div class="section white-panel mb2p">
              <h3 class="fs18 line-height1_4 mt8 mb16 ml4 mr4">法定費用も全額カードで決済</h3>
              <div class="flex align-items-center bg-gray2 radius20 pt12 pr20 pb12 pl20 mb12">
                <img src="lib/images/carcare/ic_carcare_20.svg" alt="">
                <p class="flex1 fs14 font-weight-bold ml8 mb0">車検費用は車検完了後に、<br>
                アプリ経由でお支払い</p>
              </div>
              <div class="flex align-items-center bg-gray2 radius20 pt12 pr20 pb12 pl20 mb12">
                <img src="lib/images/carcare/ic_carcare_21.svg" alt="">
                <div class="flex1">
                  <p class="fs14 font-weight-bold ml8 mb4">法定費用を含む車検費用の<br>
                  全額がカードで決済可能</p>
                  <p class="fs12 ml8 mb0">※店頭にて現金でもお支払い可能です</p>
                </div>
              </div>
            </div>
            <div v-if="detail[0].id === ''">
              <div v-if="ssInfo.komikomi_flag === 1">
                <router-link :to="{ name: 'Car', params: { tsId, ssInfo, profileInfo, nativeData }}" style="text-decoration: none;" v-on:click.native="eventTrackStartCar()">
                  <button class="button fs16 pd20 mt24 mb24 radius200 w75p">見積りを始める</button>
                </router-link>
              </div>
              <div v-else>
                <div class="section white-panel pt28 pb24 mb2p">
                  <p class="fs14">お客様のマイSSではアプリからの車検受付をしておりません。車検サービスとご利用する場合はアプリ車検を取り扱っているSSをマイSSにする必要があります。</p>
                  <div class="border-solid-gray radius16 pd20 mt20">
                    <div v-if="ssInfo.length !== 0">
                      <p class="fs14 mb4">ご登録中のマイSS</p>
                      <h2 class="fs16 font-weight-bold mb20">{{ $route.params.ssInfo.ss_name }}</h2>
                    </div>
                    <div v-else>
                      <p class="fs14 mb4">マイSSが登録されていません</p>
                    </div>
                    <a v-on:click='appChangeMySs()' style="text-decoration: none;"><button class="button fs16 mb8 w80p">マイSSを変更</button></a>
                  </div>
                </div>
              </div>
            </div>

          </section>
        </article>
      </div>

      <div class="modal_overlay">
        <div class="modal_container">
          <div class="modal_body radius8 pd24 mt8p mb8p">
            <h2 class="fs18 mb8">対象車両の条件</h2>
            <p class="fs14 mb16">・自家用の乗用車（事業用や貨物車両は除く）<br>
              ・普通/軽/小型（大型特殊車両は除く）<br>
              ・国産の8メーカー（外車やその他メーカーは除く）<br>
              －トヨタ、ホンダ、日産、ダイハツ、スズキ、三菱、マツダ、スバル<br>
              ・初度登録年月が車検実施日から遡って20年未満<br>
              ・走行距離が20万km以下</p>
            <button v-on:click="modalClose()" class="button fs16 w100p mt16 mb0 pd16 radius200">閉じる</button>
          </div>
          <!-- /.modal_body -->
        </div>
        <!-- /.modal_container -->
      </div>

    <!-- カーケアTOPに戻るボタン -->
    <form name="fm">
      <input id="tsid" type="hidden" name="tsid" v-bind:value="tsId">
      <input id="popinfoid" type="hidden" name="popinfoid" v-bind:value="popinfoid">
      <input id="otoken" type="hidden" name="otoken" v-bind:value="otoken">
    </form>
    </div>
</div>
<div v-else-if="isAgreement">
  <a id="isAgreement" v-on:click="toInitial()"></a>
  <Agreement></Agreement>
</div>
</template>

<script>
import Agreement from '@/views/Agreement.vue'
import Loading from '@/views/Loading.vue'

const IS_INITIAL = 'IS_INITIAL'
const IS_AGREEMENT = 'IS_AGREEMENT'

export default {
  data () {
    return {
      loading: true,
      modalActive: false,
      tsId: this.$route.params.nativeData.tsid,
      ssInfo: this.$route.params.ssInfo,
      profileInfo: this.$route.params.profileInfo,
      nativeData: this.$route.params.nativeData,
      detail: this.$route.params.detail,
      currentState: IS_INITIAL,
      popinfoid: this.$route.params.nativeData.popinfoid,
      otoken: this.$route.params.nativeData.otoken
    }
  },
  computed: {
    isInitial () {
      return this.currentState === IS_INITIAL
    },
    isAgreement () {
      return this.currentState === IS_AGREEMENT
    }
  },
  methods: {
    modalOpen () {
      window.modalHeight = window.pageYOffset
      // トラッキング処理
      this.nativePVset('SHAKEN_TAISHO')
      this.nativeEVENTSet('ShakenSyosaiButton', 'MOVED_SHAKEN_TAISHO', 'TAP')
      window.scrollTo(0, 0)
      this.modalActive = true
    },
    modalClose () {
      window.scrollTo(0, window.modalHeight)
      this.modalActive = false
    },
    sameUrlScroll (number) {
      if (this.$route.hash.slice(-1) === number) {
        document.getElementById(this.$route.hash.replace(/^#/, ''))
        this.$SmoothScroll(
          document.querySelector(this.$route.hash),
          500,
          null,
          null,
          'y'
        )
      }
    },
    toInitial () {
      this.currentState = IS_INITIAL
      window.scrollTo(0, 0)
    },
    toAgreement () {
      this.currentState = IS_AGREEMENT
      this.nativeEVENTSet('ShakenSyosaiButton', 'MOVED_SHAKEN_KOKANKIJYUN', 'TAP')
      window.scrollTo(0, 0)
    },
    eventTrackStartCar () {
      this.nativeEVENTSet('ShakenSyosaiButton', 'MOVED_SHAKEN_MITSUMORI', 'TAP')
    },
    appChangeMySs () {
      // 戻るボタンの出し分け
      this.appDisplayBack(false)
      if ('Android' in window) {
        /* eslint-disable-next-line no-undef */
        Android.changeMySs()
      } else if ('webkit' in window) {
        /* eslint-disable-next-line no-undef */
        webkit.messageHandlers.changeMySs.postMessage('')
      }
    }
  },
  watch: {
    $route: function (n, o) {
      if (n.hash.match(/^#/)) {
        document.getElementById(n.hash.replace(/^#/, ''))
        this.$SmoothScroll(
          document.querySelector(n.hash),
          500,
          null,
          null,
          'y'
        )
      }
    }
  },
  async mounted () {
    // 戻るボタンの出し分け
    this.appDisplayBack(true)
    this.nativePVset('SHAKEN_DETAIL')
    this.loading = false
  },
  components: {
    Agreement,
    Loading
  }
}
</script>
